// extracted by mini-css-extract-plugin
export default {"container":"nU-z","topReviewHeading":"oU-z","criticalReview":"pU-z","favorableReview":"qU-z","vsSeparator":"rU-z"};